export enum SecurityGapWidgetType {
  CLOUD_SECURITY = "cloudSecurity",
  ENDPOINT_SECURITY = "endpointSecurity",
  EMAIL_SECURITY = "emailSecurity",
  USER_DATA_GOVERNANCE = "userDataGovernance",
  ENDPOINT_DATA_GOVERNANCE = "endpointDataGovernance",
  NETWORK = "network",
  DEVICES = "devices",
  USERS = "users",
  MSP_WORKSPACE_LABELS = "mspWorkspaceLabels",
}

export enum SecurityGapAction {
  IGNORE = "ignore",
  UNIGNORE = "unignore",
  FIX_ALL = "fixAll",
  MANUAL_FIX = "manualFix",
}

export enum SecurityGapType {
  // Endpoint Security
  NO_ENDPOINTS_ADDED_FOR_MONITORING = "noEndpointsAddedForMonitoring",
  NGAV_REAL_TIME_MALWARE_AND_RANDOMWARE_PROTECTION_DISABLED = "ngavRealTimeMalwareAndRandomwareProtectionDisabled",
  NGAV_ATC_DISABLED = "ngavAtcDisabled",
  NGAV_SECURITY_SHADOW_BACKUPS_DISABLED = "ngavSecurityShadowBackupsDisabled",
  WIFI_PHISHING_NOT_ACTIVATED = "wifiPhishingNotActivated",
  // Devices
  VISIBILITY_MODE_ENABLED = "visibilityModeEnabled",
  ALLOW_SELF_UPDATE_NOT_ENABLED = "allowSelfUpdateNotEnabled",
  AGENT_REBOOT_REQUIRED = "agentRebootRequired",
  AGENT_CONFLICT = "anotherSecurityProductInstalled",
  OUTDATED_AGENT = "outdatedAgentVersion",
  UNLICENSED_DEVICES = "unlicensedDevices",
  // Cloud security
  NO_CLOUD_APPLICATION_CONNECTED = "noCloudApplicationConnected",
  CLOUD_APPLICATION_CONNECTED_ADDITIONAL_SETUP_REQUIRED = "cloudApplicationConnectedAdditionalSetupRequired",
  ACCESS_PERMISSIONS_SETTINGS_NOT_ADDED = "noAccessPermissionRulesConfigured",
  ACCESS_PERMISSIONS_ADDED_NO_AUTO_REMEDIATION_SELECTED = "accessPermissionsAddedNoAutoRemediationSelected",
  // Email Security
  EMAIL_PROTECTION_DISABLED = "emailProtectionDisabled",
  // User Data Governance
  INITIAL_USER_DATA_GOVERNANCE_CONFIGURATION_INCOMPLETE = "initialUserDataGovernanceConfigurationIncomplete",
  USER_DATA_GOVERNANCE_TYPES_NOT_CONFIGURED = "userDataGovernancePrivacyTypesNotConfigured",
  // Endpoint Data Governance
  NO_SCHEDULED_SCAN_ADDED = "noScheduledScanAdded",
  INITIAL_DEVICE_DATA_GOVERNANCE_CONFIGURATION_INCOMPLETE = "initialDeviceDataGovernanceConfigurationIncomplete",
  DEVICE_DATA_GOVERNANCE_TYPES_NOT_CONFIGURED = "deviceDataGovernanceTypesNotConfigured",
  // Users
  NO_PROTECTED_USERS_ADDED = "noProtectedUsersAdded",
}

export enum SecurityGapStatus {
  ACTIVE = "active",
  IGNORED = "ignored",
}

export enum SecurityGapTypeCategory {
  MODULE = "module",
  OTHER = "other",
}

export const securityGapTypesFilterMap: Record<SecurityGapTypeCategory, SecurityGapWidgetType[]> = {
  [SecurityGapTypeCategory.MODULE]: [
    SecurityGapWidgetType.CLOUD_SECURITY,
    SecurityGapWidgetType.ENDPOINT_SECURITY,
    SecurityGapWidgetType.EMAIL_SECURITY,
    SecurityGapWidgetType.USER_DATA_GOVERNANCE,
    SecurityGapWidgetType.ENDPOINT_DATA_GOVERNANCE,
    // SecurityGapWidgetType.NETWORK,
  ],
  [SecurityGapTypeCategory.OTHER]: [SecurityGapWidgetType.USERS, SecurityGapWidgetType.DEVICES],
};

export const securityGapTypesIconMap = {
  [SecurityGapWidgetType.CLOUD_SECURITY]: "$accessViolation",
  [SecurityGapWidgetType.ENDPOINT_SECURITY]: "$malwareEndpoint",
  [SecurityGapWidgetType.EMAIL_SECURITY]: "$email",
  [SecurityGapWidgetType.USER_DATA_GOVERNANCE]: "$userData",
  [SecurityGapWidgetType.ENDPOINT_DATA_GOVERNANCE]: "$endpointDataGovernanceS",
  [SecurityGapWidgetType.NETWORK]: "$dns",
  [SecurityGapWidgetType.DEVICES]: "$desktop",
  [SecurityGapWidgetType.USERS]: "$groups",
  [SecurityGapWidgetType.MSP_WORKSPACE_LABELS]: "$mspLabels",
};

export const securityGapLabelColorMap = {
  [SecurityGapWidgetType.CLOUD_SECURITY]: "rgb(var(--v-theme-blue-pale))",
  [SecurityGapWidgetType.ENDPOINT_SECURITY]: "rgb(var(--v-theme-purple-faint))",
  [SecurityGapWidgetType.EMAIL_SECURITY]: "rgb(var(--v-theme-blue-pale))",
  [SecurityGapWidgetType.USER_DATA_GOVERNANCE]: "rgb(var(--v-theme-red-faint))",
  [SecurityGapWidgetType.ENDPOINT_DATA_GOVERNANCE]: "rgb(var(--v-theme-orange-faint))",
  [SecurityGapWidgetType.NETWORK]: "rgb(var(--v-theme-green-pale))",
  [SecurityGapWidgetType.USERS]: "rgb(var(--v-theme-orange-faint))",
  [SecurityGapWidgetType.DEVICES]: "rgb(var(--v-theme-yellow-pale))",
  [SecurityGapWidgetType.MSP_WORKSPACE_LABELS]: "rgb(var(--v-theme-purple-faint))",
};
